import React from 'react';
import classnames from 'classnames';

// Types
import { ReactionType } from './types';

// Components
import { WpButton } from '../button';
import WpEmoji from '../emoji/WpEmoji';
import { WpPopover, WpPopoverToggle, WpPopoverContent } from '../popover';
import ReactionPopover from './ReactionPopover';

// Styles
import './QuickReactionButton.scss';

type Props = {
  emoji?: string;
  _reactions: ReactionType[];
  currentUserId: number;
  showNumber?: boolean;
  showPopover?: boolean;
  onClick?: Function;
  isPicker?: boolean;
  users?: any;
};

const QuickReactionButton = ({
  emoji,
  _reactions,
  currentUserId,
  showNumber = true,
  showPopover = true,
  onClick,
  isPicker = false,
  users,
}: Props) => {
  const reactions = _reactions.filter(r => r.data === emoji);
  const currentUserReacted = Boolean(reactions.find(r => +r.userId === +currentUserId));

  const handleClick = () => {
    if (onClick) onClick({ emoji });
  };

  const baseClassName = 'QuickReactionButton';
  const classes = classnames(
    `${baseClassName}__button`,
    currentUserReacted ? `${baseClassName}__button--selected` : ''
  );

  const inner = (
    <>
      <span className={`${baseClassName}__button__emoji`}>
        <WpEmoji emoji={`:${emoji}:`} size={16} />
      </span>
      {showNumber && <span className={`${baseClassName}__button__label`}>{reactions.length}</span>}
    </>
  );

  return (
    <>
      {isPicker ? (
        <WpButton
          onClick={handleClick}
          size="sm"
          color="gray"
          variant={currentUserReacted ? 'primary' : 'tertiary'}
          icon
          rounded
        >
          {inner}
        </WpButton>
      ) : (
        <>
          {showPopover && users?.length > 0 ? (
            <div className={baseClassName}>
              <WpPopover showArrow={false}>
                <WpPopoverToggle>
                  <button className={classes} onClick={handleClick} type="button">
                    {inner}
                  </button>
                </WpPopoverToggle>
                <WpPopoverContent>
                  <ReactionPopover _reactions={_reactions} users={users} emoji={emoji} />
                </WpPopoverContent>
              </WpPopover>
            </div>
          ) : (
            <button className={`${baseClassName} ${classes}`} onClick={handleClick} type="button">
              {inner}
            </button>
          )}
        </>
      )}
    </>
  );
};

export default QuickReactionButton;
